import type {
  CreateMappingFormDTO,
  JDPositionMappingDTO,
  UpdateMappingFormDTO,
} from "@/modules/jd-mapping/domain/contracts";
import type {
  JDPositionMappingListResult,
  PositionWithJDListResult,
} from "@/modules/jd-mapping/domain/types";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

function toFormData(input: Record<string, unknown>): FormData {
  const fd = new FormData();
  Object.entries(input).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (v instanceof File) fd.append(k, v);
    else if (Array.isArray(v) || typeof v === "object") {
      fd.append(k, JSON.stringify(v));
    } else fd.append(k, String(v));
  });
  return fd;
}

export const jdMappingApi = {
  async listPositions(
    query: OffsetPageQueryDTO,
  ): Promise<PositionWithJDListResult> {
    const url = new URL(`${config.apiUrl}/jd-mapping/positions`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<PositionWithJDListResult>(url.toString());
  },

  async getMappingHistory(
    positionId: string,
  ): Promise<{ data: JDPositionMappingDTO[] }> {
    return fetcher.get<{ data: JDPositionMappingDTO[] }>(
      `${config.apiUrl}/jd-mapping/positions/${positionId}/history`,
    );
  },

  async getCurrentMapping(positionId: string): Promise<JDPositionMappingDTO> {
    return fetcher.get<JDPositionMappingDTO>(
      `${config.apiUrl}/jd-mapping/positions/${positionId}/current`,
    );
  },

  async create(input: CreateMappingFormDTO) {
    return fetcher.postForm<{ value: { id: string } }>(
      `${config.apiUrl}/jd-mapping`,
      toFormData(input),
    );
  },

  async update(positionId: string, input: UpdateMappingFormDTO) {
    return fetcher.putForm<{ value: { id: string } }>(
      `${config.apiUrl}/jd-mapping/positions/${positionId}`,
      toFormData(input),
    );
  },

  async cancel(positionId: string, notes?: string) {
    return fetcher.post<{ value: { id: string } }>(
      `${config.apiUrl}/jd-mapping/positions/${positionId}/cancel`,
      { notes },
    );
  },
};
